// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_I57","cls2":"PaperClaimedToast-cls2_fHc PaperClaimedToast-cls1_I57"};